export default "__VITE_ASSET__53cde863__"